module.exports = require('../build/DayPickerInput');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-day-picker/DayPickerInput/index.js
 ** module id = 3295
 ** module chunks = 0
 **/